module.exports = __webpack_public_path__ + "media/images/vp/samples/18-bcca8495c2074d540af220ca4f66a73e.jpg";